"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Role Types:
 *
 * admin - They can do everything
 * contributor - They can do everything, except modify users or templates
 * readyOnly - They can see all but can't do anything.
 * restricted - They can only see the stuff they authored. They don't have access to any other users stuff.
 */
var roles = {
  admin: {
    value: 'admin',
    label: 'Full Access'
  },
  contributor: {
    value: 'contributor',
    label: 'Limited Access'
  },
  readOnly: {
    value: 'readOnly',
    label: 'ReadOnly'
  },
  restricted: {
    value: 'restricted',
    label: 'Restricted'
  }
};
roles.all = Object.keys(roles).map(function (key) {
  return roles[key];
});
var _default = exports["default"] = roles;